import React, { useRef } from "react";
import { BackButton, InputWithLabel } from "../../../components/micro";
import { useLocation, useNavigate } from "react-router-dom";
import { headChat } from "../../../assets/image";
import FileUploadChoose from "../../../commons/FileUploadChoose";
import ReactSelect from "react-select";
import { uploadFile } from "../../../redux/uploadFile/slice";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { InputError } from "../../../commons/MicroComponents";
import FileView from "../components/FileView";
import { createServicesRequest } from "../../../redux/serviceRequest/slice";

const OpenBankAccount = () => {
  const ParticularTypeOptions = [
    { value: "ic", label: "IC" },
    { value: "passport", label: "Passport" },
  ];
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );

  // Validation
  const validationSchema = Yup.object().shape({
    particular_type: Yup.object()
      .nullable()
      .required("Particular Type is required"),
    website: Yup.string().url("Invalid URL").required("Website is required"),
    handphone_number: Yup.string()
      .required("Handphone Number is required")
      .matches(/^\d{8,15}$/, "Handphone number must be 8-15 digits")
      .min(8, "Handphone number must be at least 8 digits")
      .max(15, "Handphone number must be at most 15 digits"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    ic_front: Yup.mixed().when("particular_type", {
      is: (particular_type) => particular_type?.value === "ic",
      then: Yup.mixed().required("IC Front is required"),
    }),
    ic_back: Yup.mixed().when("particular_type", {
      is: (particular_type) => particular_type?.value === "ic",
      then: Yup.mixed().required("IC Back is required"),
    }),
    proof_of_address: Yup.mixed().required("Proof of Address is required"),
    company_bizfile_Constitution: Yup.mixed().required(
      "Company Bizfile is required"
    ),
    company_sales_contract: Yup.mixed().required(
      "Company Sales Contract is required"
    ),
    company_supplier_listing: Yup.mixed().required(
      "Company Supplier Listing is required"
    ),
    rental_agreement: Yup.mixed().required("Rental Agreement is required"),
  });

  // handle File Upload
  const handleFileUpload = (fieldName, setFieldValue) => (e) => {
    const file = e?.target?.files[0];
    const type = file?.type;
    const formData = new FormData();
    formData.append("type", "service-request");
    formData.append("file", file);
    formData.append(
      "document_type",
      type === "application/pdf" ? "doc" : "img"
    );

    dispatch(uploadFile(formData)).then((res) => {
      if (res.type === "uploadFile/fulfilled") {
        setFieldValue(fieldName, res.payload.data);
      }
    });
  };

  // Proceed with request
  const handleSubmit = (values) => {
    const payload = {
      details: {
        ...(values.passport && { passport: values.passport?.url }),
        ...(values.ic_front && { ic_front: values.ic_front?.url }),
        ...(values.ic_back && { ic_back: values.ic_back?.url }),
        website: values?.website,
        handphone_number: values?.handphone_number,
        email: values?.email,
        particular_type: values?.particular_type?.value,
        proof_of_address: values?.proof_of_address?.url,
        company_bizfile_Constitution: values?.company_bizfile_Constitution?.url,
        company_sales_contract: values?.company_sales_contract?.url,
        company_supplier_listing: values?.company_supplier_listing?.url,
        rental_agreement: values?.rental_agreement?.url,
      },
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };

    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0 ||
        detail?.price === undefined
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  return (
    <>
      <div className="space-y-5">
        <BackButton
          onClick={() => {
            navigate("/service");
          }}
        />
        <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
          <img src={headChat} alt="img" />
          <div className="space-y-2 font-ebGaramond">
            <p className="text-xl">We see that you will need a request on:</p>
            <p className="text-3xl">Open Bank Account</p>
          </div>
        </div>
        {/* Payment Button */}
        <a
          className="hidden"
          ref={buttonRef}
          href={createServicesRequestData?.data?.url}
        >
          Pay Now
        </a>
        <Formik
          initialValues={{
            particular_type: "",
            website: "",
            handphone_number: "",
            email: "",
            passport: "",
            ic_front: null,
            ic_back: null,
            proof_of_address: null,
            company_bizfile_Constitution: null,
            company_sales_contract: null,
            company_supplier_listing: null,
            rental_agreement: null,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            setFieldValue,
            handleBlur,
          }) => (
            <Form className="space-y-5">
              <div className="space-y-3 border-b-2 border-secondary_grey pb-4">
                <p className="text-2xl font-ebGaramond">
                  Let us guide u though the process:
                </p>
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>1.</span>
                  <p>Provide us with some personal details </p>
                </div>
                <p className="text-sm">
                  i. You can choose either IC (Front & Back) or Passport
                </p>
                <div>
                  <ReactSelect
                    className={"p-0"}
                    id="particular_type"
                    placeholder="Particular Type"
                    options={ParticularTypeOptions}
                    isLoading={false}
                    value={values.particular_type}
                    isClearable
                    onChange={(option) => {
                      setFieldValue("particular_type", option);
                    }}
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: `1px solid ${
                          errors.particular_type && touched.particular_type
                            ? "red"
                            : "#0000003B"
                        }`,
                        borderRadius: "0.3rem",
                        paddingTop: "2px",
                        paddingBottom: "2px",
                        boxShadow: "none",
                        "&:hover": {
                          border: "1px solid #cdddeb",
                        },
                      }),
                    }}
                  />
                  {errors.particular_type && touched.particular_type ? (
                    <InputError errorTitle={errors.particular_type} />
                  ) : null}
                </div>
              </div>
              {/* Upload IC Front Or Passport */}
              {values.particular_type && (
                <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                  <p className="text-sm">
                    &#8226;{" "}
                    {values.particular_type.value === "ic"
                      ? "IC front"
                      : "Passport"}
                  </p>
                  <div>
                    {values?.ic_front || values?.passport ? (
                      <FileView
                        document_type={
                          values.particular_type.value === "ic"
                            ? values?.ic_front?.document_type
                            : values?.passport?.document_type
                        }
                        onClose={() =>
                          setFieldValue(
                            values.particular_type.value === "ic"
                              ? "ic_front"
                              : "passport",
                            null
                          )
                        }
                        url={
                          values.particular_type.value === "ic"
                            ? values?.ic_front?.url
                            : values?.passport?.url
                        }
                      />
                    ) : (
                      <FileUploadChoose
                        errorBorder={
                          values.particular_type.value === "ic"
                            ? errors.ic_front && touched.ic_front
                            : errors.passport && touched.passport
                        }
                        name={
                          values.particular_type.value === "ic"
                            ? "ic_front"
                            : "passport"
                        }
                        handleFileChange={handleFileUpload(
                          values.particular_type.value === "ic"
                            ? "ic_front"
                            : "passport",
                          setFieldValue
                        )}
                      />
                    )}

                    {values.particular_type.value === "ic" ? (
                      <>
                        {errors.ic_front && touched.ic_front ? (
                          <InputError errorTitle={errors.ic_front} />
                        ) : null}
                      </>
                    ) : (
                      <>
                        {errors.passport && touched.passport ? (
                          <InputError errorTitle={errors.passport} />
                        ) : null}
                      </>
                    )}
                  </div>
                  {values?.particular_type?.value === "ic" && (
                    <>
                      <p className="text-sm">&#8226; IC back</p>
                      {values?.ic_back ? (
                        <FileView
                          document_type={values?.ic_back?.document_type}
                          onClose={() => setFieldValue("ic_back", null)}
                          url={values?.ic_back?.url}
                        />
                      ) : (
                        <div>
                          <FileUploadChoose
                            errorBorder={errors.ic_back && touched.ic_back}
                            name="ic_back"
                            handleFileChange={handleFileUpload(
                              "ic_back",
                              setFieldValue
                            )}
                          />
                          {errors.ic_back && touched.ic_back ? (
                            <InputError errorTitle={errors.ic_back} />
                          ) : null}
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
              <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                <p className="text-sm">ii. Proof of Address</p>
                {/* Upload Proof of Address */}
                <div>
                  {values?.proof_of_address ? (
                    <FileView
                      document_type={values?.proof_of_address?.document_type}
                      onClose={() => setFieldValue("proof_of_address", null)}
                      url={values?.proof_of_address?.url}
                    />
                  ) : (
                    <FileUploadChoose
                      errorBorder={
                        errors.proof_of_address && touched.proof_of_address
                      }
                      name="proof_of_address"
                      handleFileChange={handleFileUpload(
                        "proof_of_address",
                        setFieldValue
                      )}
                    />
                  )}
                  {errors.proof_of_address && touched.proof_of_address ? (
                    <InputError errorTitle={errors.proof_of_address} />
                  ) : null}
                </div>
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>2.</span>
                  <p>Provide us with some company documents</p>
                </div>
                <p className="text-sm">i. Company Bizfile + Constitution</p>
                {/* Upload Company Bizfile + Constitution */}
                <div>
                  {values?.company_bizfile_Constitution ? (
                    <FileView
                      document_type={
                        values?.company_bizfile_Constitution?.document_type
                      }
                      onClose={() =>
                        setFieldValue("company_bizfile_Constitution", null)
                      }
                      url={values?.company_bizfile_Constitution?.url}
                    />
                  ) : (
                    <FileUploadChoose
                      errorBorder={
                        errors.company_bizfile_Constitution &&
                        touched.company_bizfile_Constitution
                      }
                      name="company_bizfile_Constitution"
                      handleFileChange={handleFileUpload(
                        "company_bizfile_Constitution",
                        setFieldValue
                      )}
                    />
                  )}
                  {errors.company_bizfile_Constitution &&
                  touched.company_bizfile_Constitution ? (
                    <InputError
                      errorTitle={errors.company_bizfile_Constitution}
                    />
                  ) : null}
                </div>
              </div>
              <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                {/* Company Website */}
                <p className="text-sm">ii. Company Website</p>
                <InputWithLabel
                  className={
                    errors.website && touched.website ? "input-error" : "border"
                  }
                  idFromName={"website"}
                  type={"url"}
                  value={values.website}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label={"Website"}
                  name="website"
                  errors={errors.website && touched.website}
                  errorsText={errors.website}
                />
              </div>
              <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                <p className="text-sm">
                  iii. Company Sales Contract, Quotation
                </p>
                {/* Upload Company Sales Contract, Quotation */}
                <div>
                  {values?.company_sales_contract ? (
                    <FileView
                      document_type={
                        values?.company_sales_contract?.document_type
                      }
                      onClose={() =>
                        setFieldValue("company_sales_contract", null)
                      }
                      url={values?.company_sales_contract?.url}
                    />
                  ) : (
                    <FileUploadChoose
                      errorBorder={
                        errors.company_sales_contract &&
                        touched.company_sales_contract
                      }
                      name="company_sales_contract"
                      handleFileChange={handleFileUpload(
                        "company_sales_contract",
                        setFieldValue
                      )}
                    />
                  )}
                  {errors.company_sales_contract &&
                  touched.company_sales_contract ? (
                    <InputError errorTitle={errors.company_sales_contract} />
                  ) : null}
                </div>
              </div>
              <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                <p className="text-sm">iv. Company Supplier Name Listing</p>
                {/* Upload Company Supplier Name Listing */}
                <div>
                  {values?.company_supplier_listing ? (
                    <FileView
                      document_type={
                        values?.company_supplier_listing?.document_type
                      }
                      onClose={() =>
                        setFieldValue("company_supplier_listing", null)
                      }
                      url={values?.company_supplier_listing?.url}
                    />
                  ) : (
                    <FileUploadChoose
                      errorBorder={
                        errors.company_supplier_listing &&
                        touched.company_supplier_listing
                      }
                      name="company_supplier_listing"
                      handleFileChange={handleFileUpload(
                        "company_supplier_listing",
                        setFieldValue
                      )}
                    />
                  )}
                  {errors.company_supplier_listing &&
                  touched.company_supplier_listing ? (
                    <InputError errorTitle={errors.company_supplier_listing} />
                  ) : null}
                </div>
              </div>
              <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                <p className="text-sm">v. Rental Agreement</p>
                <div>
                  {values?.rental_agreement ? (
                    <FileView
                      document_type={values?.rental_agreement?.document_type}
                      onClose={() => setFieldValue("rental_agreement", null)}
                      url={values?.rental_agreement?.url}
                    />
                  ) : (
                    <FileUploadChoose
                      errorBorder={
                        errors.rental_agreement && touched.rental_agreement
                      }
                      name="rental_agreement"
                      handleFileChange={handleFileUpload(
                        "rental_agreement",
                        setFieldValue
                      )}
                    />
                  )}
                  {errors.rental_agreement && touched.rental_agreement ? (
                    <InputError errorTitle={errors.rental_agreement} />
                  ) : null}
                </div>
              </div>
              <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                <p className="text-sm">vi. Client contact HP no. and Email</p>
                <InputWithLabel
                  className={
                    errors.handphone_number && touched.handphone_number
                      ? "input-error"
                      : "border"
                  }
                  idFromName={"handphone_number"}
                  value={values.handphone_number}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type={"number"}
                  label={"Handphone Number"}
                  name="handphone_number"
                  errors={errors.handphone_number && touched.handphone_number}
                  errorsText={errors.handphone_number}
                />
                <InputWithLabel
                  className={
                    errors.email && touched.email ? "input-error" : "border"
                  }
                  idFromName={"email"}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  type={"email"}
                  label={"Email"}
                  name="email"
                  errors={errors.email && touched.email}
                  errorsText={errors.email}
                />
              </div>
              <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>3.</span>
                  <p>SGCorpHub will be reviewing the provided information</p>
                </div>
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>4.</span>
                  <p>
                    SGCorpHub will be arrange an Online Video call reference &
                    liaising with bank
                  </p>
                </div>
                <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                  <span>5.</span>
                  <p>Bank account created!</p>
                </div>
                <p className="text-sm">
                  Once the request is opened. You can easily manage it over at
                  “On-Going” service page.
                </p>
              </div>
              <div className="flex items-center justify-between space-x-1  bg-light_primary_shades rounded-lg px-4 py-3">
                <p className="font-semibold">Total Payable :</p>
                <div>
                  <p className="text-xs">Amount</p>
                  <p className="text-xl">
                    {service?.service_requests_count >=
                    service?.detail?.no_of_free_request
                      ? `$${service?.detail?.price}`
                      : "Free"}
                  </p>
                </div>
              </div>
              <div className="box !rounded-xl flex items-center justify-between">
                <button
                  type="submit"
                  className={`${
                    createServicesRequestLoading
                      ? "btn-outline-disabled"
                      : "btn-theme"
                  }  uppercase`}
                  disabled={createServicesRequestLoading}
                >
                  {createServicesRequestLoading
                    ? "Loading.."
                    : "Proceed with request"}
                </button>
                <div>
                  <p className="text-xs">Total:</p>
                  <p className="text-xl">
                    {service?.service_requests_count >=
                    service?.detail?.no_of_free_request
                      ? `$${service?.detail?.price}`
                      : "Free"}
                  </p>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default OpenBankAccount;
